import { useEffect } from "react";
import { launchBetBy, registerBetByInterop } from "../services/betby.service";
import { useNavigate } from "react-router-dom";
import userDeviceStore from "../../../store/device.store";
import { killBetBy } from "../../../assets/js/betby";
import homeService from "../../home/services/home.service";
import { localStorageService } from "../../../services";
import { GameVertical } from "../../../models/constants/gameVertical";

export default function SportsbookPlus() {
  const navigate = useNavigate();
  const accessModeSource = userDeviceStore((state) => state.accessModeSource);

  useEffect(() => {
    let mounted = true;

    const init = async () => {
      const activeVerticals = await homeService.fetchActiveVerticals();
      const isSportsEnabled =
        activeVerticals.isSuccess &&
        (activeVerticals.data?.details?.some(
          (v) => v.name.toLowerCase() === GameVertical.Sports.toLowerCase(),
        ) ??
          false);

      if (!mounted) {
        return;
      }

      if (!isSportsEnabled) {
        navigate("/");
        return;
      }

      if (localStorageService.getItem("isUserLoggedIn") === true) {
        const userVerticals = await homeService.fetchUserVerticals();
        const userVerticalList = (userVerticals.data?.verticalsCsv ?? "")
          .toLowerCase()
          .split(",")
          .map((s) => s.trim())
          .filter((s) => s.length > 0);

        if (userVerticalList.includes(GameVertical.Sports.toLowerCase())) {
          navigate("/");
          return;
        }
      }

      registerBetByInterop(navigate, accessModeSource.sourceType);
      launchBetBy(navigate, false, accessModeSource.sourceType);
    };

    init();

    return () => {
      mounted = false;
      killBetBy();
    };
  }, [navigate, accessModeSource.sourceType]);

  return (
    <div className="iframe-area relative z-10" id="betByIframe">
      <div id="betby"></div>
    </div>
  );
}